import React from 'react';

const MarketplaceIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" {...props}>
    <g className="Marketplace-icon_svg__Product-Logo/Marketplace">
      <path
        d="m12.963 3.043 8 8 .883-.883a1.924 1.924 0 0 0 0-2.717l-5.283-5.28a1.924 1.924 0 0 0-2.717 0l-.883.884zm-9.92 8 8-8-.883-.883a1.924 1.924 0 0 0-2.717 0l-5.28 5.287a1.924 1.924 0 0 0 0 2.716l.883.884zm8 9.92-8-8-.883.884a1.924 1.924 0 0 0 0 2.716l5.283 5.284a1.924 1.924 0 0 0 2.717 0zm9.92-8-8 8 .883.884a1.924 1.924 0 0 0 2.717 0l5.283-5.284a1.924 1.924 0 0 0 0-2.716zm-8.96 1.92-2.88-2.88 2.88-2.88 2.88 2.88zm0-9.92-7.04 7.04 7.04 7.04 7.04-7.04z"
        className="Marketplace-icon_svg__Icon"
      ></path>
    </g>
  </svg>
);

export default MarketplaceIcon;
